import styles from './project-memory-book-actions.module.less';
import { Link, useLocation } from 'react-router';
import { THEMES } from '../../utils/cms-utils';
import Main from '../../frame/main/Main';
import GenericHelmet from '../generic-helmet/GenericHelmet';
import { getSharingTextForProject, isActive } from '../project-model';
import ThemeContext from '../../context/theme-context';
import { PaymentCompactInfoCardContainer } from '../payment/payment-compact-info-card-container/PaymentCompactInfoCardContainer';
import {
    ACCEPTING_MEMORIAL_TEXT_KEY,
    AND_TEXT_KEY,
    CANCEL_TEXT_KEY,
    PRIVACY_POLICY_TEXT_KEY,
    TERMS_TEXT_KEY,
} from '../i18n/project-i18n-model';
import { PrimaryButton, SecondaryButton } from '@sb1/ffe-buttons-react';
import I18nText from '../i18n/I18nText';
import { LinkText, SmallText } from '@sb1/ffe-core-react';
import VisibleIf from '../../components/VisibleIf';
import GeneralInfo from '../../components/GeneralInfo';

const MemoryBookActionPage = ({
    project,
    headingText,
    isLoading,
    isSubmitted,
    successMessage,
    onDismiss,
    onNavigateToPayment,
    children,
}) => {
    const location = useLocation();

    return (
        <ThemeContext.Provider value={{ theme: { mainColor: THEMES.BLUE_THEME_SMALL_SCREEN_SAND_LARGE_SCREEN } }}>
            <Main bodyClassName={styles.outsideContainer}>
                <GenericHelmet
                    title={project.title}
                    description={getSharingTextForProject(project)}
                    path={location.pathname}
                    imageUrl={project.img_url}
                    projectId={project.id}
                >
                    <div className={styles.container}>
                        <PaymentCompactInfoCardContainer project={project} headingText={headingText} />
                        <VisibleIf isVisible={isActive(project)}>
                            {!isSubmitted && (
                                <div>
                                    <div className={styles.innerContainer}>{children}</div>
                                    <div className={styles.termsContainer}>
                                        <SmallText>
                                            <I18nText textKey={ACCEPTING_MEMORIAL_TEXT_KEY} />{' '}
                                            <Link to={'/vilkar'} target={'_blank'}>
                                                <I18nText textKey={TERMS_TEXT_KEY} />
                                            </Link>{' '}
                                            <I18nText textKey={AND_TEXT_KEY} />{' '}
                                            <Link to={'/personvern'} target={'_blank'}>
                                                <I18nText textKey={PRIVACY_POLICY_TEXT_KEY} />
                                            </Link>
                                            .
                                        </SmallText>
                                    </div>
                                </div>
                            )}
                            {isSubmitted && (
                                <div className={styles.successContainer}>
                                    <p>{successMessage}</p>
                                    <p>Noen velger også å bidra med et beløp</p>
                                    <div className={styles.actionButtons}>
                                        <SecondaryButton onClick={onDismiss} size="lg">
                                            Nei, takk
                                        </SecondaryButton>
                                        <PrimaryButton onClick={onNavigateToPayment} size="lg">
                                            Støtt spleisen
                                        </PrimaryButton>
                                    </div>
                                </div>
                            )}
                        </VisibleIf>
                        <VisibleIf isVisible={!isActive(project)}>
                            <GeneralInfo info="Det er ikke mulig å tenne lys eller skrive minneord til denne minnespleisen fordi den ikke er aktiv" />
                        </VisibleIf>
                    </div>
                    {!isLoading && (
                        <div className={styles.cancelButtonStandard}>
                            <LinkText onClick={onDismiss}>
                                <I18nText textKey={CANCEL_TEXT_KEY} />
                            </LinkText>
                        </div>
                    )}
                </GenericHelmet>
            </Main>
        </ThemeContext.Provider>
    );
};

export default MemoryBookActionPage;
